import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostSignCooperationAgreement from './PostSignCooperationAgreement';

interface ISignCooperationAgreementProps {
  onSuccess?: () => void;
}

interface AxError {
  message?: string;
  store?: {
    title?: string[];
  };
  title?: string[];
}

const usePostSignCooperationAgreement = ({
  onSuccess,
}: ISignCooperationAgreementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISignCooperationAgreementPayload) => {
      return PostSignCooperationAgreement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (data: AxiosError<AxError>) => {
      const errorData = data?.response?.data;

      // Extract the error message from nested structure
      let errorMessage: string | undefined;

      if (errorData?.store?.title?.[0]) {
        errorMessage = errorData.store.title[0];
      } else if (errorData?.title?.[0]) {
        errorMessage = errorData.title[0];
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      }

      if (errorMessage === 'Store with this title already exists.') {
        toast.error('فروشگاهی با این نام قبلاً ثبت شده است');
      } else if (errorMessage) {
        toast.error(decodeHtmlEntities(errorMessage));
      } else {
        toast.error('مشکلی پیش آمده است');
      }
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostSignCooperationAgreement};

const decodeHtmlEntities = (text: string): string => {
  if (!Boolean(text)) return '';
  return text.replace(/&#x([0-9A-Fa-f]+);/g, (match, hex) => {
    return String.fromCharCode(parseInt(hex, 16));
  });
};
